import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deviceId: null,
  userSettings: {},
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setUserSettings: (state, action) => {
      state.userSettings = action.payload;
    },
    setDeviceId: (state, action) => {
      state.deviceId = action.payload;
    },
  },
});

export const selectSettings = (state) => state.settings;
export const { setUserSettings, setDeviceId } = settingsSlice.actions;
export default settingsSlice.reducer;
